var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixedWingAircraft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55969 32.74H13.6197C14.6597 32.74 15.4997 31.9 15.4997 30.86V28.54H7.67969V30.86C7.67969 31.9 8.51969 32.74 9.55969 32.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4498 32.74H38.3898C37.3498 32.74 36.5098 31.9 36.5098 30.86V28.54H44.3398V30.86C44.3398 31.9 43.4898 32.74 42.4498 32.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55969 32.74H13.6197C14.6597 32.74 15.4997 31.9 15.4997 30.86V28.54H7.67969V30.86C7.67969 31.9 8.51969 32.74 9.55969 32.74Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4498 32.74H38.3898C37.3498 32.74 36.5098 31.9 36.5098 30.86V28.54H44.3398V30.86C44.3398 31.9 43.4898 32.74 42.4498 32.74Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9094 14.5L23.6094 21.15H25.9994H28.3894L27.0894 14.5C26.7294 13.47 25.2794 13.47 24.9094 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9094 14.5L23.6094 21.15H25.9994H28.3894L27.0894 14.5C26.7294 13.47 25.2794 13.47 24.9094 14.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0702 24.49H2.37023C0.820232 24.49 0.460232 26.67 1.93023 27.16L23.0702 32.89V24.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0702 24.49H2.37023C0.820232 24.49 0.460232 26.67 1.93023 27.16L23.0702 32.89V24.49Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9297 24.49H49.6297C51.1797 24.49 51.5397 26.67 50.0697 27.16L28.9297 32.9V24.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9297 24.49H49.6297C51.1797 24.49 51.5397 26.67 50.0697 27.16L28.9297 32.9V24.49Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0111 37.22C30.0925 37.22 33.4011 33.401 33.4011 28.69C33.4011 23.979 30.0925 20.16 26.0111 20.16C21.9297 20.16 18.6211 23.979 18.6211 28.69C18.6211 33.401 21.9297 37.22 26.0111 37.22Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0111 37.22C30.0925 37.22 33.4011 33.401 33.4011 28.69C33.4011 23.979 30.0925 20.16 26.0111 20.16C21.9297 20.16 18.6211 23.979 18.6211 28.69C18.6211 33.401 21.9297 37.22 26.0111 37.22Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 25.97H29.01",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedWingAircraft);
export default __webpack_public_path__ + "static/media/FixedWingAircraft.5eb25eed3ab971387f60dc9f083bde74.svg";
export { ForwardRef as ReactComponent };